export default "__VITE_ASSET___Ve6aJre__"